<div class="show-booking-modal">
  <div class="show-booking-modal__header">
    <h5 class="show-booking-modal__title">
      <i class="fa-solid fa-edit mr-2"></i>
      {{ isEditMode ? 'Edit' : 'Add' }} Map Others Item
    </h5>
    <button class="show-booking-modal__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>

  <div class="show-booking-modal__body">
    <form #editForm="ngForm">
      <div class="mb-3">
        <label for="title" class="form-label">Title *</label>
        <input
          type="text"
          class="form-control"
          id="title"
          [(ngModel)]="title"
          name="title"
          placeholder="Enter title"
          required
        />
      </div>

      <div class="mb-3">
        <label for="icon" class="form-label">Icon</label>
        <div class="icon-selector-section">
          <div class="icon-grid">
            <div 
              *ngFor="let iconOption of promoIcons" 
              class="icon-option"
              [class.selected]="icon === iconOption"
              (click)="onIconSelected(iconOption)"
            >
              <i [class]="iconOption"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label for="description" class="form-label">Description *</label>
        <textarea
          class="form-control"
          id="description"
          [(ngModel)]="description"
          name="description"
          rows="4"
          placeholder="Enter description"
          required
        ></textarea>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="my-button-3 secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="my-button-3" (click)="save()">Save</button>
      </div>
    </form>
  </div>
</div>

